import { gql } from 'graphql-request'
import {
  FileText,
  ListOrdered,
  MessageSquareText,
  Lightbulb,
  Video
} from 'lucide-react'

import { useMutation } from '@hooks/graphql'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@/components/ui/dialog'
import Loader from '@components/Loader'

const CREATE_BLOCK_MUTATION = gql`
  mutation createBlock($input: CreateBlockInput!) {
    createBlock(input: $input) {
      block {
        blockId
        position
      }
      errors {
        message
      }
    }
  }
`

const AddBlockModal = ({ id, index, closeModal, isOpen, refetch, setSelectedBlockId }) => {
  const { mutate: createBlock, isLoading: isCreating } = useMutation({
    gqlMutation: CREATE_BLOCK_MUTATION,
    onSuccess: async data => {
      await refetch()

      setSelectedBlockId(data.createBlock.block.blockId)
      closeModal()
    }
  })

  return (
    <Dialog open={isOpen} onOpenChange={closeModal}>
      <DialogContent className='sm:max-w-2xl'>
        <DialogHeader>
          <DialogTitle>Add block</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Add a new block to your lesson.
        </DialogDescription>
        <div className='flex flex-col h-full'>
          <Choose>
            <When condition={isCreating}>
              <Loader className='my-5 self-center' />
            </When>

            <Otherwise>
              <p className='text-lg font-semibold'>Content</p>

              <div className='grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 mt-3 gap-3 mb-5'>
                <button
                  type='button'
                  onClick={() => createBlock({ input: { educatorProjectId: id, position: index, blockType: 'TEXT' } })}
                  className='flex flex-row items-center mb-2 hover:bg-muted hover:font-semibold p-2 rounded-md'
                >
                  <FileText className='size-8 mr-2 bg-purple-200 text-purple-900 rounded-md p-1 shrink-0' />
                  Content
                </button>

                <button
                  type='button'
                  onClick={() => createBlock({ input: { educatorProjectId: id, position: index, blockType: 'VIDEO' } })}
                  className='flex flex-row items-center mb-2 hover:bg-muted hover:font-semibold p-2 rounded-md'
                >
                  <Video className='size-8 mr-2 bg-purple-200 text-purple-900 rounded-md p-1 shrink-0' />
                  Video
                </button>
              </div>

              <p className='text-lg font-semibold'>Questions</p>

              <div className='grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 mt-3 gap-3'>
                <button
                  type='button'
                  onClick={() => createBlock({ input: { educatorProjectId: id, position: index, blockType: 'FREE_RESPONSE' } })}
                  className='flex flex-row items-center gap-2 mb-2  hover:bg-muted hover:font-semibold p-2 rounded-md'
                >
                  <MessageSquareText className='size-8 mr-2 bg-orange-200 text-orange-900 rounded-md p-1 shrink-0' />
                  Free response
                </button>

                <button
                  type='button'
                  onClick={() => createBlock({ input: { educatorProjectId: id, position: index, blockType: 'QUESTION' } })}
                  className='flex flex-row items-center gap-2 mb-2  hover:bg-muted hover:font-semibold p-2 rounded-md'
                >
                  <ListOrdered className='size-8 mr-2 bg-yellow-200 text-yellow-900 rounded-md p-1 shrink-0' />
                  Multiple choice
                </button>

                <button
                  type='button'
                  onClick={() => createBlock({ input: { educatorProjectId: id, position: index, blockType: 'REFLECTION' } })}
                  className='flex flex-row items-center gap-2 mb-2  hover:bg-muted hover:font-semibold p-2 rounded-md'
                >
                  <Lightbulb className='size-8 mr-2 bg-red-200 text-red-900 rounded-md p-1 shrink-0' />
                  Reflection
                </button>
              </div>
            </Otherwise>
          </Choose>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AddBlockModal
